export default {
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
        },
        PartnerId: {
            class: "lookup",
            dataName: 'PartnerId',
            type: 'number',
            title: 'Partner Id',
            width: 100,
            hidden: false,
            readOnly: false
        },
		PartnerName: {
			class: "lookup",
			dataName: 'Partner/FullName',
			type: 'string',
			title: 'PartnerFullName',
			width: 100,
			hidden: false,
			readOnly: true
		},
		UnitClass: {
			class: 'value',
			dataName: 'UnitClass',
			type: 'string',
			title: 'Unit Class',
			width: 100,
			hidden: false,
            readOnly: false
		},
		UnitType: {
			class: 'value',
			dataName: 'UnitType',
			type: 'string',
			title: 'Unit Type',
			width: 100,
			hidden: false,
            readOnly: false
 		},
        FMVPercentage: {
			class: 'value',
			dataName: 'FMVPercentage',
			type: 'number',
			title: 'FMV %',
			template: '#=kendo.format("{0:p}", FMVPercentage / 100)#',	
			width: 100,
			hidden: false,
			editable: false
		},
        ProjectedValue: {
			class: "value",
			dataName: 'ProjectedValue',
			type: 'number',
			title: 'Projected Value',
			template:'#=kendo.format("{0:c}", ProjectedValue)#',
			width: 100,
			hidden: false,
			readOnly: false
        },
        CurrentValue: {
			class: "value",
			dataName: 'CurrentValue',
			type: 'number',
			title: 'Current Value',
			template:'#=kendo.format("{0:c}", CurrentValue)#',
			width: 100,
			hidden: false,
			readOnly: false
        },
	}
}